import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import Image from "react-bootstrap/Image";
import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";
import Validator from "validator";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import Media from "react-media";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";

const MapSetupScreenTwoWrapper = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
          >
            <div className="col-12 onboarding_process_screen_left-backbutton">
              {state.is_suggest_new_open === true ? (
                // <span
                //   className="back_button-link"
                //   onClick={localProps.onToggleHandler(
                //     "is_suggest_new_open",
                //     false
                //   )}
                // >
                //   <Image
                //     src={require("../../../../assets/images/Icon/onBoardBack.png")}
                //     alt="Back Button"
                //     title="Back Button"
                //   />
                // </span>
                // <div className="col-12">
                //   <BackLogoIconButton
                //     displayBackText={true}
                //     displayArrow={true}
                //     workWithLinkORClick={true}
                //     backButtonClicked={localProps.onToggleHandler(
                //       "is_suggest_new_open",
                //       false
                //     )}
                //   />
                // </div>
                <div>
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        workWithLinkORClick={true}
                        backButtonClicked={localProps.onToggleHandler(
                          "is_suggest_new_open",
                          false
                        )}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader
                      onClick={localProps.onToggleHandler(
                        "is_suggest_new_open",
                        false
                      )}
                    />
                  </Media>
                </div>
              ) : null || state.are_you_part_of_chain === false ? (
                <div>
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        workWithLinkORClick={false}
                        backButtonClicked={"/restaurantinfo"}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader onClick={props.handleFormHide} />
                  </Media>
                </div>
              ) : (
                <div>
                  <Media query="(min-width: 992px)">
                    <div className="col-12">
                      <BackLogoIconButton
                        displayBackText={true}
                        displayArrow={true}
                        workWithLinkORClick={true}
                        backButtonClicked={localProps.onBackButtonChainPage}
                      />
                    </div>
                  </Media>
                  <Media query="(max-width: 991px)">
                    <MobileTopHeader
                      onClick={localProps.onBackButtonChainPage}
                    />
                  </Media>
                </div>
              )}
            </div>
            <div className="onboarding_process_screen-button-map onboarding_process_screen-left-mapinside">
              <div>
                {/* <div className="display-toggle-stepup-button">
                  <RightSidePannel selectedTab={1} />
                </div> */}
                <TopTextReusableComponent
                  headingText={
                    // state.is_suggest_new_open === true
                    //   ? "Business Chain Details"
                    //   :
                    "Business Settings"
                  }
                  headingParagraph={
                    // state.is_suggest_new_open === true
                    //   ? "Please enter details about your Business chain"
                    //   :
                    "Enter the details about your Business Establishment"
                  }
                />
              </div>

              {props.children}
              <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}

                <Media query="(min-width: 992px)">
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    onClick={
                      state.are_you_part_of_chain === false
                        ? () => props.history.push("/restaurantinfo")
                        : state.is_suggest_new_open === true
                        ? localProps.onBackButtonSuggestNew
                        : localProps.onBackButtonChainPage
                    }
                  />
                </Media>
                <Media query="(max-width: 991px)">
                  <ReusableOnboardingButton
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    onClick={
                      state.are_you_part_of_chain === false
                        ? props.handleFormHide
                        : state.is_suggest_new_open === true
                        ? localProps.onBackButtonSuggestNew
                        : localProps.onBackButtonChainPage
                    }
                  />
                </Media>
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonText="Next"
                  buttonType="button"
                  disabled={errorHandler(state)}
                  onClick={
                    // state.actionButton === false
                    //   ? localProps.onWithOutApiCall
                    //   :
                    state.are_you_part_of_chain === false
                      ? localProps.onhandleSubmit
                      : state.is_suggest_new_open === true
                      ? localProps.onSuggestNewSubmitHandler
                      : localProps.onhandleSubmit
                  }
                  buttonClass={`onboarding_button_link_reusable ${
                    errorHandler(state)
                      ? "onboarding_button_link_reusable_gray ml-3"
                      : "onboarding_button_link_reusable_red ml-3"
                  }`}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              selectedProgressBarOne="active"
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MapSetupScreenTwoWrapper;

const errorHandler = (state) => {
  if (state.are_you_part_of_chain === false) {
    return false;
  } else if (state.is_suggest_new_open === true && isEmpty(state.errors)) {
    if (
      state.title === "" ||
      state.address === "" ||
      state.area === "" ||
      state.city === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no.length <
        10 ||
      state.enquiry_emails[state.enquiry_emails.length - 1] === "" ||
      !Validator.isEmail(
        state?.enquiry_emails[state.enquiry_emails.length - 1] || ""
      ) ||
      state.icon.length <= 0
    ) {
      return true;
    } else {
      return false;
    }
  } else if (state.restaurant_chain_id !== "") {
    return false;
  } else {
    return true;
  }
};
